import { useSearchParams } from 'react-router-dom';
import type { VideoSummary } from '@streamr/shared';
import { VideoGrid } from '../components/VideoGrid';
import { flattenPages, useFeed } from '../api/hooks/useDiscovery';

export const HomePage = (): JSX.Element => {
  const [params, setParams] = useSearchParams();
  const tag = params.get('tag') ?? undefined;
  const feed = useFeed(tag);

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-xl font-semibold">{tag !== undefined ? `#${tag}` : 'Home'}</h1>
        {tag !== undefined && (
          <button
            type="button"
            onClick={() => setParams({})}
            className="text-sm text-brand-400 hover:text-brand-500"
          >
            Clear filter
          </button>
        )}
      </div>

      <VideoGrid
        videos={flattenPages<VideoSummary>(feed.data)}
        isLoading={feed.isLoading}
        error={feed.error}
        hasNextPage={feed.hasNextPage}
        isFetchingNextPage={feed.isFetchingNextPage}
        fetchNextPage={() => void feed.fetchNextPage()}
        emptyTitle="No videos yet"
        emptyHint="Once a channel publishes something, it shows up here."
      />
    </div>
  );
};
